module.exports = __webpack_public_path__ + "static/media/learning-24.e9a7c5e6.png";